import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import PunchOutN2RulesAction from '../app/store/actions/punchOutN2Rules';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class PunchOutN2RulesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      orderBy: 'ASC',
      field: 'code',
    };
  }

  componentDidMount() {
    this.searchRules();
  }

  updateValues = async (page = 1) => {
    await this.setState({ page });
    await this.searchRules();
  }

  searchRules = async () => {
    const {
      page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, false, orderBy, field);
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchRules();
  }

  render() {
    const { limit, page } = this.state;
    const { rules = {} } = this.props;

    const tableHeader = [
      { key: 'code', value: I18n.t('code') },
      { key: 'name', value: I18n.t('name') },
      { key: 'description', value: I18n.t('description') },
      { key: 'type', value: I18n.t('type') },
      { key: 'action', value: I18n.t('action') },
    ];
    const tableData = (rules.punchOutN2Rules || []).map((row, index) => ({
      key: index,
      code: row.code,
      name: row.name,
      description: row.description,
      type: row.type,
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => history.push({
                  pathname: ROUTES.FORM,
                  screenComming: 'punchout-n2-rule',
                  item: row,
                })}
              >
                <Translate value="edit" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'punchout-n2-rule' }} />
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <Table
          title={I18n.t('punchoutN2Rules')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={rules.count && rules.count.count}
          // searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, force, order, field) => dispatch(
    PunchOutN2RulesAction.getPunchOutN2Rules(limit, skip, force, order, field),
  ),
});

const mapStateToProps = state => ({
  rules: state.punchOutN2Rules && state.punchOutN2Rules.punchOutN2Rules,
});

export default connect(mapStateToProps, mapDispatchToProps)(PunchOutN2RulesPage);
